// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__zw0qF","rightAdornment":"Header_rightAdornment__13Gs-"};